<style lang="sass" scoped>
@import '../../../../../css/core';

.reservations-table-reservations-shift-body {
  .-row {
    position: relative;
  }
}

.-cell.no-attend {
  background-color: #bfbfbf;
}

.-cell.empty {
  background-color: #000000;
}

.-cell.break {
  background-color: #bc8f8f;
}

.-cell.block {
  background-color: #7f7f7f;
  white-space: nowrap;
}
</style>


<template>
<div class="reservations-table-reservations-shift-body">
  <reservation-form
      v-ref:reservation-form
      :shop="shop"
      :shops="shops"
      :staffs="staffs"
      :availabilities="availabilities"
      :menus="menus"
      :dyestuffs="dyestuffs"
      :business-hour="businessHour"
  ></reservation-form>
  <div class="-row" v-bind:style="rowStyle">
    <div
        v-for="t in ticks"
        class="-cell"
        v-bind:class="{ empty: isEmpty(t), break: isBreak(t), block: isBlock(t), 'no-attend': noAttend }"
        v-bind:style="cellStyleByTick(t,(isEmpty(t) || isBlock(t)))"
        :data-tick="t.toISOString()"
        @click="openReservationCreateForm"
        @mouseover="$dispatch('tick-over', t)"
        @mouseout="$dispatch('tick-out', t)"
    >
    <div v-if="blockStart(t)" v-bind:style="blockStyle(t)">
      {{ blockReason(t) }}
    </div>
    </div>
    <box
        v-for="r in reservations"
        :shop="shop"
        :business-hour="businessHour"
        :px-per-minute="pxPerMinute"
        :reservation="r"
        :track="r.track"
        :height="boxHeight"
        :margin-top="boxMarginTop"
        :margin-bottom="boxMarginBottom"
        :staff="staff"
        @click-reservation="openReservationUpdateForm"
    ></box>
    <time-pointer
        :business-hour="businessHour"
        :px-per-minute="pxPerMinute"
        :height="height"
    ></time-pointer>
  </div>
</div>
</template>


<script>
import moment from 'moment'
import $ from 'jquery'

export default {
  name: 'reservations-table-reservations-shift-body',
  mixins: [require('../body.vue')],
  props: {
    shop: {
      type: Object,
      required: true,
    },
    shops: {
      type: Array,
      required: true,
    },
    reservations: {
      type: Array,
      required: true,
    },
    staffs: {
      type: Array,
      required: true,
    },
    availabilities: {
      type: Array,
      required: true,
    },
    menus: {
      type: Array,
      required: true,
    },
    dyestuffs: {
      type: Array,
      required: true,
    },
    boxHeight: {
      type: Number,
      required: true,
    },
    boxMarginTop: {
      type: Number,
      required: true,
    },
    boxMarginBottom: {
      type: Number,
      required: true,
    },
    shifts: {
      type: Array,
      required: false,
    },
    staff: {
      type: Object,
      required: false,
    },
    noAttend: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    targetShifts () {
      if (!this.staff || !this.shifts) {
        return []
      }
      return this.shifts.filter(r => r.staff === this.staff.pk)
    },
  },
  methods: {
    openReservationCreateForm(event) {
      let tick = $(event.target).data('tick')
      if (tick === undefined || this.isBlock(tick)) {
        return
      }
      this.$refs.reservationForm.create(tick)
    },
    openReservationUpdateForm(reservation) {
      this.$refs.reservationForm.update(reservation)
    },
    isEmpty(tick) {
      if (this.staff) {
        if (this.targetShifts.some(shift => (moment(shift.startAt) <= tick && tick < moment(shift.endAt)))) {
          return false
        }
        return true
      }
      return false
    },
    isBreak(tick) {
      if (!this.staff) {
        return false
      }
      if (this.targetShifts.some(shift => ((shift.breakStartAt_1 && moment(shift.breakStartAt_1) <= tick && tick < moment(shift.breakEndAt_1)) ||
                                           (shift.breakStartAt_2 && moment(shift.breakStartAt_2) <= tick && tick < moment(shift.breakEndAt_2))))) {
        return true
      }
      return false
    },
    isBlock (tick) {
      if (!this.staff) {
        return false
      }
      if (this.targetShifts.some(shift => ((shift.blockStartAt_1 && moment(shift.blockStartAt_1) <= tick && tick < moment(shift.blockEndAt_1)) ||
                                           (shift.blockStartAt_2 && moment(shift.blockStartAt_2) <= tick && tick < moment(shift.blockEndAt_2))))) {
        return true
      }
      return false
    },
    blockStart (tick) {
      if (this.targetShifts.some(shift => (shift.blockStartAt_1 && tick.isSame(shift.blockStartAt_1)) ||
                                          (shift.blockStartAt_2 && tick.isSame(shift.blockStartAt_2)))) {
        return true
      }
      return false
    },
    getBlock (tick) {
      let blockReason = null
      let blockEnd = null
      this.targetShifts.forEach(shift => {
        if (tick.isSame(shift.blockStartAt_1)) {
          blockEnd = shift.blockEndAt_1
          blockReason = shift.blockReason_1
          return false
        } else if (tick.isSame(shift.blockStartAt_2)) {
          blockEnd = shift.blockEndAt_2
          blockReason = shift.blockReason_2
          return false
        }
      })
      let tmp = {
        reason: blockReason,
        blockEnd: moment(blockEnd),
      }
      return tmp
    },
    blockReason (tick) {
      let tmp = this.getBlock(tick)
      return tmp.reason
    },
    blockStyle (tick) {
      let tmp = this.getBlock(tick)
      let cnt = 0
      let tmpTick = moment(tick)
      while (tmpTick < tmp.blockEnd) {
        cnt++
        tmpTick = tmpTick.add(10, 'minutes')
      }
      let width = cnt * 30
      return {
        width: `${width}px`,
        'position': 'relative',
        'text-align': 'center',
        'color': 'white',
        'background-color': '#7f7f7f',
      }
    },
  },
  components: {
    box: require('./box.vue'),
    reservationForm: require('../../modal-form/index.vue'),
    timePointer: require('../time-pointer.vue'),
  },
}
</script>



// WEBPACK FOOTER //
// body.vue?59155093